import styled from "styled-components";

// Top-aligned: the text wraps, so the banner grows with it and the bell and the
// close button stay on its first line; the call to action stays centred.
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;
  padding: 14px 18px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 53, 99, 0.1);

  .MuiIconButton-root {
    flex-shrink: 0;
    color: ${(props) => props.theme.brand.soft};
  }
`;

export const IconChip = styled.button`
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border: none;
  padding: 0;
  border-radius: 50%;
  background: #fff4e0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: filter 0.15s;

  &:hover {
    filter: brightness(0.95);
  }

  .MuiSvgIcon-root {
    color: ${(props) => props.theme.colors.tertiary};
    font-size: 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-grow: 1;
  min-width: 0;
`;

export const Eyebrow = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: ${(props) => props.theme.colors.tertiary};
`;

export const Title = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.theme.brand.navy};
  line-height: 1.3;
  overflow-wrap: anywhere;
`;

export const Message = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.brand.muted};
  line-height: 1.4;
  overflow-wrap: anywhere;
`;

export const CtaButton = styled.button`
  border: none;
  flex-shrink: 0;
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${(props) => props.theme.brand.gold};
  color: ${(props) => props.theme.brand.navyDeep};
  font-size: 13px;
  font-weight: 700;
  padding: 11px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: filter 0.15s;

  &:hover {
    filter: brightness(0.95);
  }
`;
